<template lang="pug">
.print-section
    BaseHeader(
        :titulo='$t("relatorioExportacao.detalhe.titulo")',
        :voltarPara='{ route: "RelatorioExportacao" }'
        :btnTexto='$t("relatorioExportacao.detalhe.exportarRelatorio")'
        icon='mdi mdi-file-download-outline'
        exibeBotao
        @btnHeaderClicado='exportarRelatorio'
        :desabilitaBotao='carregando || !detalhes?.relatorioPronto'
    )
    .visualizar-relatorio
        .visualizar-relatorio__bloco
            h3.visualizar-relatorio__titulo {{ $t("relatorioExportacao.detalhe.dadosNavio") }}
            .visualizar-relatorio__card
                .resume
                    .resume__item
                        .resume__label {{ $t("relatorioExportacao.detalhe.numeroBL") }}
                        .resume__value {{ detalhes?.idExterno || '-' }}
                    .resume__item
                        .resume__label {{ $t("relatorioExportacao.detalhe.navio") }}
                        .resume__value {{ detalhes?.navio || '-' }}

        .visualizar-relatorio__bloco
            .visualizar-relatorio__totalizadores
                BlocoInformacaoSkeleton(:carregando='carregando')
                    BlocoInformacao(
                        v-for='item in totalizadores',
                        :key='item.id',
                        :titulo='item.titulo',
                        :numero='item.numero',
                    )
                        template(slot='icone')
                            i.mdi.mdi-chart-bar

        .visualizar-relatorio__bloco
            BlocoResumo(
                :resumo='resumo'
                :titulo='$t("relatorioExportacao.resumoCars.titulo")'
                :subTitulo='$t("relatorioExportacao.resumoCars.subTitulo")'
            )

        .visualizar-relatorio__bloco
            h3.visualizar-relatorio__titulo {{ $t("relatorioExportacao.detalhe.listagemCars") }}
            CarsTabela(
                :tabelaData='cars'
                :paginacao='paramsCarLista'
                :carregando='carregando'
                :relatorio='detalhes'
            )
        .visualizar-relatorio__bloco
            h3.visualizar-relatorio__titulo {{ $t("relatorioExportacao.detalhe.listagemContratos") }}
            ContratosTabela(
                :tabelaData='contratos'
                :paginacao='paramsContratoLista'
                :carregando='carregando'
                :detalhes='detalhes'
            )
</template>
<script>
import { defineComponent } from 'vue';
import service from '@/modules/relatorio-exportacao/services/RelatorioService';
import BaseHeader from '@/components/BaseHeader.vue';
import BlocoInformacao from '@/modules/relatorio-exportacao/components/BlocoInformacao.vue';
import BlocoInformacaoSkeleton from '@/modules/relatorio-exportacao/components/BlocoInformacaoSkeleton.vue';
import BlocoResumo from '@/modules/relatorio-exportacao/components/BlocoResumo.vue';
import CarsTabela from '@/modules/relatorio-exportacao/components/CARsTabela.vue';
import ContratosTabela from '@/modules/relatorio-exportacao/components/ContratosTabela.vue';

export default defineComponent({
    components: {
        BaseHeader,
        BlocoInformacao,
        BlocoInformacaoSkeleton,
        BlocoResumo,
        CarsTabela,
        ContratosTabela
    },
    data() {
        return {
            row: null,
            detalhes: null,
            cars: [],
            contratos: [],
            carregando: false,
            paramsCarLista: {
                pagina: 0,
                itensPorPagina: 10,
                sort: 'id',
                por: 'desc'
            },
            paramsContratoLista: {
                pagina: 0,
                itensPorPagina: 10,
                sort: 'id',
                por: 'desc'
            }
        };
    },
    async mounted() {
        this.row = this.$route.params.id;
        if (this.row) {
            this.carregando = true;
            await this.obterRelatorio();
            await this.obterContratoLista();
            await this.obterCarLista();
            this.carregando = false;
        }
    },
    computed: {
        totalizadores() {
            if (!this.detalhes) return [];
            const totalizadores = Object.keys(this.detalhes?.sumarioContratos).map(key => ({
                id: key,
                titulo: this.$t(`relatorioExportacao.totalizadoresDetalhe.${key}`),
                numero: this.detalhes?.sumarioContratos[key]
            }));
            return totalizadores;
        },
        resumo() {
            if (!this.detalhes) return [];
            const resumo = Object.keys(this.detalhes?.sumarioPropriedades).map(key => ({
                id: key,
                titulo: this.$t(`relatorioExportacao.sumarioPropriedades.${key}`),
                valor: this.detalhes?.sumarioPropriedades[key]
            }));
            return resumo;
        }
    },
    methods: {
        obterRelatorio() {
            const id = this.row;

            service.fetchRelatorioById({id})
            .then(response => {
                this.detalhes = response.data;
            });
        },
        obterContratoLista() {
            this.carregando = true;

            const params = {
                id: this.row,
                page: this.paramsContratoLista.pagina,
                size: this.paramsContratoLista.itensPorPagina,
                search: ''
            };

            service.fetchRelatorioContratosById(params)
            .then(response => {
                this.contratos = response.data.dados;
                this.paramsContratoLista.total = response.data.meta.totalRegistros;
                this.paramsContratoLista.pagina = response.data.meta.paginaAtual;
            });
        },
        obterCarLista() {
            this.carregando = true;
            const params = {
                id: this.row,
                page: this.paramsCarLista.pagina,
                size: this.paramsCarLista.itensPorPagina,
                search: ''
            };
            service.fetchRelatorioCarsById(params)
            .then(response => {
                this.cars = response.data.dados;
                this.paramsCarLista.total = response.data.meta.totalRegistros;
                this.paramsCarLista.pagina = response.data.meta.paginaAtual;
            });
        },
        mudarPaginaContratos(pagina) {
            this.paramsContratoLista.page = pagina;
            this.obterContratoLista();
        },
        mudarPaginaCars(pagina) {
            this.paramsCarLista.page = pagina;
            this.obterCarLista();
        },
        async exportarRelatorio() {
            try {
                const id = this.detalhes.id;

                await service.downloadRelatorio(id);
                this.$notify.success({
                    message: this.$t('relatorioExportacao.lista.downloadSucesso')
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t('relatorioExportacao.lista.downloadErro')
                });
            }
        }
    }
});
</script>

<style lang="scss">
.visualizar-relatorio {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__titulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        color: var(--primary);
    }

    &__bloco {
        width: 100%;
    }

    &__totalizadores .el-skeleton {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        width: 100%;
        flex-wrap: wrap;
        #bloco-informacao {
            cursor: pointer;
        }
    }

    &__card {
        background-color: $white;
        padding: 16px;
        border-radius: $default-border-radius;
        @include default-box-shadow();

        &--header {
            padding: 0;
        }
    }

    &__dados-pesquisados {
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(2, 1fr);
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background-color: var(--primary);
        color: $white;
        height: 40px;
        padding: 16px;
        border: none;
        outline: none;
        border-radius: $default-border-radius;
        cursor: pointer;

        &--secondary {
            background: $white;
            color: var(--primary);
            border: 1px solid var(--primary);
        }

        &:disabled {
            background: #f5f5f5;
            color: #545454 !important;
            cursor: not-allowed;

            i {
                color: #545454 !important;
            }
        }
    }

    &__button-box,
    &__button-box.el-button--primary {
        background-color: var(--primary) !important;
        color: $white !important;
        border: none;
        outline: none;

        &:hover {
            background-color: var(--primary) !important;
            color: $white !important;
            border: none;
            outline: none;
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 16px;
    }

    & .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid $default-border-color;
        padding: 12px 16px 16px;

        &__theader {
            font-size: 14px;
            min-width: 60px;
            font-weight: bold;
            text-align: center;
            color: var(--primary);
        }
    }

    & .card-bd {
        padding: 16px;
        max-height: 300px;
        min-height: 100px;
        overflow-x: hidden;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 8px;
        }

        &::-webkit-scrollbar-thumb {
            border: 2px solid var(--white);
        }
    }

    & .resume {
        display: flex;
        gap: 100px;

        &__item {
            display: flex;
            flex-direction: column;
            gap: 5px;
            justify-content: space-between;

            &--normal {
                flex-direction: row;
            }
        }

        &__text {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        &__action {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 60px;
        }

        &__label {
            font-weight: bold;
            color: var(--primary);
        }

        &--vertical {
            flex-direction: column;
            gap: 5px;
        }
    }
}
</style>
